export default {"src":"/_next/static/media/tablet-cracked.1cadfd93.svg","height":75,"width":80};